import type { Modifier } from '@wix/patterns-dnd-kit-core';
import { restrictToBoundingRect } from '@wix/patterns-dnd-kit-modifiers';

export const restrictContainerToWindowEdges: Modifier = ({
  transform,
  windowRect,
  scrollableAncestorRects,
  draggingNodeRect,
}) => {
  const containerRect = scrollableAncestorRects[0];

  if (!containerRect || !windowRect || !draggingNodeRect) {
    return transform;
  }

  return restrictToBoundingRect(
    transform,
    {
      ...draggingNodeRect,
      left: containerRect.left,
      right: containerRect.right,
    },
    windowRect,
  );
};
